import { Grid } from '@material-ui/core';
import styled from 'styled-components';
const QueryHeaderStyle = {
  floatLeft: {
    float: 'left'
  },
  DataTypeBtn: {
    margin: '5px 4em'
  },
  btnMarBR: {
    margin: '0px 8px 0px 0px',
    borderRadius: '20px'
  }
};
export default QueryHeaderStyle;
export const StyledGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
  margin: 24px 0px 8px 6px;
  width: 100%;
`;
export const StyledGridItem = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;